// Select Modal
<template>
  <v-dialog v-model="config.status.active" max-width="600">
    <v-card>
      <v-card-title class="blue darken-2 white--text">
        <span class="headline">滞在手配に追加します</span>
      </v-card-title>
      <v-card-text class="body-1 text-xs-left">
        <v-container>
          <v-form ref="form" v-model="form.valid" lazy-validation>
            <v-row dense class="pb-4">
              <v-col cols="12" class="px-3">
                <v-select required
                  v-model="form.owner"
                  label="大家を選択して下さい"
                  item-text="label"
                  item-value="value"
                  :items="getOwnerItems"
                  :rules="rules.owner"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="secondary" @click="close">止める</v-btn>
        <v-spacer></v-spacer>
        <v-btn depressed
          color="secondary white--text"
          :loading="isLoading"
          :disabled="!form.valid"
          @click.stop="submit"
        >追加する</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'authorProgsModalsStayArrange',
  props: [
    'title', 'message', 'colors'
  ],
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false
        }
      },
      form: {
        valid: true,
        cid: '',
        owner: ''
      },
      rules: {
        owner: [
          v => !!v || '必須項目です'
        ]
      },
      store: {
        title: '',
        message: '',
        callback: null,
        colors: {}
      }
    }
  },
  mounted () {
  },
  methods: {
    init: function (req) {
      this.update(req)
    },
    update: function (req) {
      const { cid } = req
      this.$set(this, 'form', {
        valid: true,
        cid: cid,
        owner: ''
      })
    },
    open: function (req) {
      this.$set(this.config.status, 'active', true)
      this.init(req)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate() && this.form.cid) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(this.$url.api + 'progs/insert/item/meta/stay', {
            cid: this.form.cid,
            form: {
              owner: this.form.owner
            }
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('done', { owner: this.form.owner })
              this.close()
            }
            this.$set(this.config.status, 'loading', false)
          }).catch(err => {
            console.log(err)
            this.$set(this.config.status, 'loading', false)
          })
        })
      }
    }
  },
  computed: {
    isActive () {
      return this.config.status.active
    },
    isLoading () {
      return this.config.status.loading
    },
    getOwnerItems () {
      return Object.keys(this.$mango.arrange.stay.owners).map(key => {
        return {
          value: key,
          label: this.$mango.arrange.stay.owners[key]
        }
      })
    }
  }
}
</script>
